import Vue from 'vue';
import VueCardFormat from 'vue-credit-card-validation';

Vue.use(VueCardFormat);
